import React from 'react'
import {Box, Typography} from '@mui/material'
import {CsvValidationSummary} from 'models/CsvValidationSummary'
import styles from './styles'

type Props = {
  result: CsvValidationSummary
}

const ValidationSummaryTiles: React.FC<Props> = ({result}) => (
  <Box sx={styles.statRow}>
    <Box sx={styles.statTile}>
      <Typography sx={styles.statTileValue} variant="h6">
        {result.totalRows}
      </Typography>
      <Typography variant="body2">Total</Typography>
    </Box>
    <Box sx={styles.statTile}>
      <Typography sx={styles.statTileValue} variant="h6">
        {result.validCount}
      </Typography>
      <Typography variant="body2">Valid</Typography>
    </Box>
    <Box sx={styles.statTile}>
      <Typography
        sx={result.errorCount > 0 ? styles.statTileValueError : styles.statTileValue}
        variant="h6">
        {result.errorCount}
      </Typography>
      <Typography variant="body2">Errors</Typography>
    </Box>
    <Box sx={styles.statTile}>
      <Typography
        sx={result.warningCount > 0 ? styles.statTileValueWarn : styles.statTileValue}
        variant="h6">
        {result.warningCount}
      </Typography>
      <Typography variant="body2">Warnings</Typography>
    </Box>
  </Box>
)

export default ValidationSummaryTiles
